import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-view-carousel-image',
  templateUrl: './view-carousel-image.component.html',
  styleUrls: ['./view-carousel-image.component.scss'],
})
export class ViewCarouselImageComponent implements OnInit {

  @Input() url: any;

  constructor(public modalController : ModalController) { }

  ngOnInit() {}

  closeModal(){
    this.modalController.dismiss();
  }

}
